import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useRef, useState } from 'react';
import classnames from 'classnames';
import styles from "./CollapsibleUpwardsPanel.module.scss";
import { Button } from "../Button/Button/Button";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CollapsibleUpwardsPanel = function CollapsibleUpwardsPanel(_ref) {
  var _contentRef$current$s, _contentRef$current;
  var buttonText = _ref.buttonText,
    children = _ref.children,
    wrapperClassName = _ref.wrapperClassName,
    buttonTextOpen = _ref.buttonTextOpen,
    onClick = _ref.onClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var contentRef = useRef(null);
  var onClickInternal = function onClickInternal() {
    setIsOpen(!isOpen);
    if (onClick) {
      onClick(!isOpen);
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classnames('collapsible-upwards-panel', styles['collapsible-upwards-panel']),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.content,
      ref: contentRef,
      style: {
        maxHeight: isOpen ? ((_contentRef$current$s = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.scrollHeight) !== null && _contentRef$current$s !== void 0 ? _contentRef$current$s : '0') + 'px' : '0px'
      },
      children: children
    }), /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.buttonWrapper, wrapperClassName),
      onClick: onClickInternal,
      children: [/*#__PURE__*/_jsx(Button, {
        type: "link",
        className: styles.button,
        children: isOpen ? buttonTextOpen : buttonText
      }), isOpen ? /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "#070517",
        children: /*#__PURE__*/_jsx("path", {
          d: "M12.1162 9.72266C12.4108 9.48235 12.8455 9.49981 13.1201 9.77441L17.1201 13.7744C17.413 14.0673 17.413 14.5421 17.1201 14.835C16.8272 15.1279 16.3525 15.1279 16.0596 14.835L12.5898 11.3652L9.12012 14.835C8.82722 15.1279 8.35246 15.1279 8.05957 14.835C7.76668 14.5421 7.76668 14.0673 8.05957 13.7744L12.0596 9.77441L12.1162 9.72266Z",
          fill: "#070517"
        })
      }) : /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        children: /*#__PURE__*/_jsx("path", {
          d: "M16.0596 10.165C16.3525 9.87215 16.8272 9.87215 17.1201 10.165C17.413 10.4579 17.413 10.9327 17.1201 11.2256L13.1201 15.2256C12.8272 15.5185 12.3525 15.5185 12.0596 15.2256L8.05957 11.2256C7.76668 10.9327 7.76668 10.4579 8.05957 10.165C8.35246 9.87215 8.82722 9.87215 9.12012 10.165L12.5898 13.6348L16.0596 10.165Z",
          fill: "#070517"
        })
      })]
    })]
  });
};